// import React from "react";

import React, { useState } from "react";
import { Player } from "@lottiefiles/react-lottie-player";

import {
  Banner,
  Container,
  Description,
  IconBanner,
  Centro,
  Description2,
  Icon,
  ImgBanner,
  ViewImages,
  ViewGalery,

 
} from "./styles";
import { useTheme } from "../../hooks/useTheme";

import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import { useNavigate } from "react-router-dom";
import { icons, images } from "../../constants";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const Landing = () => {
  const { themeFile } = useTheme();
    const navigate = useNavigate();
    const handleNavigate = (url) => {
      navigate(url);
    };


  const imagesGalery = [
      {
        original: images.bannerMinutoEscola,
      },
      
      {
        original: images.bannerCineEducacao,
      },

      {
        original: images.bannerEncerramentodaOlimpiada,
      },

      {
        original: images.bannerMatematicaemRede,
      },
  ];


  return (

    
    <Container>
      <Menu />  
      {/* <Title>Tudo o que você precisa, em um só lugar.</Title>1 */}

      {/* <Title>Página temporariamente em manutenção.</Title>
        <center>
          <img src={images.manut} width="200"></img>
        </center> */}
      
      {/* <Description>
        Seja bem-vindo ao canal pedagógico, um espaço que visa promover a
        comunicação sobre as diversas ações no âmbito pedagógico da Secretaria
        Municipal de Educação de Mogi das Cruzes. No menu superior esquerdo você
        pode conhecer algumas ações do departamento pedagógico, além de contar
        com uma área restrita aos profissionais da rede municipal. Você poderá
        acompanhar a agenda de eventos do auditório do Cemforpe e do
        departamento, as novidades da biblioteca, a produção de materiais,
        avaliações, formações, entre outros.
      </Description> */}
     
      <Banner highContrast={themeFile.COLORS.highContrast}>  

    <IconBanner>
      <ViewGalery>
        <ViewImages>
            <ImageGallery items={imagesGalery} showBullets={true} autoPlay={true} showNav={false} slideInterval={4000} />
        </ViewImages>
      </ViewGalery>          
      <ImgBanner src={icons.iconpessoa} />
    </IconBanner>     

      {/* <Title>  
          Espaço construído pelo Deped, que visa estreitar a comunicação 
          entre todos os profissionais da rede. Faça seu
          login através do menu superior esquerdo e aproveite todos os conteúdos
          disponíveis para você. 
       </Title> */}

      </Banner>
      
      <Centro>
      
        <Description onClick={() => handleNavigate("/sobre")}>
          <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.conheca_black
                   : icons.iconconhecablue
                   }
               alt="Sobre o Departamento"
            />
          SOBRE  
        </Description>
     
        <Description2 onClick={() => handleNavigate("/cidadeleitora")}>
        <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.iconProject_black
                   : icons.iconProject_white
                   }
               alt="Projetos"
            />
          PROJETOS
      </Description2>

      <Description
        
        onClick={() => handleNavigate("/documentos")}>
      {/* DOCUMENTOS */}
        <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.documentos_black
                   : icons.documentos_purple
                   }
               alt="Documentos"
            />
          DOCUMENTOS            
      </Description>

      </Centro>

      <Centro>
      <Description2 onClick={() => handleNavigate("/biblioteca")}>
          <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.biblioteca_black
                   : icons.biblioteca
                   }
               alt="Biblioteca"
            />
          BIBLIOTECA  
        </Description2>

      <Description onClick={() => handleNavigate("/videoteca")}>
          <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.videoteca_black
                   : icons.videoteca_purple
                   }
               alt="Videoteca"
            />
          VIDEOTECA  
      </Description>

      <Description2 onClick={() => handleNavigate("/plataformas")}>
          <Icon
               src={
                   themeFile.COLORS.highContrast
                   ? icons.plataforma_black
                   : icons.plataforma
                   }
               alt="Plataformas"
            />
          PLATAFORMAS  
      </Description2>

      </Centro> 


      {/* <Centro>
      <Description>
        Este espaço foi construído pelo Departamento Pedagógico.
      </Description>

      <Description2>
        Este espaço foi construído pelo Departamento Pedagógico.
      </Description2>

      <Description>
        Este espaço foi construído pelo Departamento Pedagógico.
      </Description>

      </Centro>

      {/* <Banner highContrast={themeFile.COLORS.highContrast}>
        <IconBanner>
          <Player
            autoplay={true}
            loop={true}
            controls={false}
            src={images.iconPessoas}
            style={{ width: "100%" }}
          />
        </IconBanner>
      </Banner>
      
      <Description>
        Este espaço foi construído pelo Departamento Pedagógico, os conteúdos aqui exibidos são criados a partir das diversas equipes e projetos
        existentes procurando estreitar a comunicação entre todos os profissionais da rede. Faça seu login através do menu superior esquerdo e
        aproveite todos os conteúdos disponíveis para você. Lembrando que o login deve ser feito somente com a conta corporativa, não é 
        necessário nenhum cadastro prévio. Qualquer problema com seu login, por favor, envie um e-mail para canalpedagogico@se-pmmc.com.br.
      </Description> */}

      <Footer />

    </Container>
  );
};

export default Landing; 
